const cardCarouselStyle = {
  dots: true,
  arrows: false,
  infinite: true,
  speed: 1000,
  autoplay: true,
  autoplaySpeed: 3000,
  slidesToScroll: 1,
  swipeToSlide: true,
};

export default cardCarouselStyle;